import { EffectsMap } from 'use-effect-reducer'

import {
  REFUND_ECOM_MUTATION,
  RefundEcwidSaleVariables,
  RefundEcwidSaleResponse,
} from '../../helpers/mutations'
import { ECOM_ERROR_CODE } from '../../helpers/constants'
import {
  RefundEffect,
  RefundEffectsMapArgs,
  RefundEvent,
  RefundState,
} from './types'

export const getRefundEffectsMap = (
  args: RefundEffectsMapArgs
): EffectsMap<RefundState, RefundEvent, RefundEffect> => {
  const {
    amount,
    originalSaleId,
    registerId,
    registerSalePaymentId,
    apolloClient,
    getErrorData,
  } = args
  return {
    ecomRefundEffect: (_state, effect, dispatch) => {
      apolloClient
        .mutate<RefundEcwidSaleResponse, RefundEcwidSaleVariables>({
          mutation: REFUND_ECOM_MUTATION,
          variables: {
            input: {
              amount,
              originalSaleID: originalSaleId,
              registerID: registerId,
              registerSalePaymentID: registerSalePaymentId,
            },
          },
        })
        .then(result => {
          if (result.data?.refundEcwidSale.success) {
            dispatch({
              type: 'COMPLETE_REFUND',
            })
          } else {
            const { errorMessage, retryable } = getErrorData(
              ECOM_ERROR_CODE.DEFAULT_REFUND
            )
            dispatch({
              type: 'ERROR',
              errorMessage,
              retryable,
            })
          }
        })
        .catch(error => {
          const errorCode = error?.graphQLErrors?.[0]?.extensions?.code
          const { errorMessage, retryable } = getErrorData(errorCode)
          dispatch({
            type: 'ERROR',
            errorMessage,
            retryable,
          })
        })
    },
  }
}
